/*
 * カテゴリメガメニュー: PC 第3階層のドリルダウン制御
 *
 * - 第2階層ボタン [data-category-open] をクリックで第3階層ビューへ切り替え
 * - 戻るボタン [data-category-back] をクリックで第2階層ビューへ戻る
 * - フォーカスは、ドリルダウン時は戻るボタン、戻り時は元のボタンへ移動
 * - マウス等のポインタ操作時は focusVisible: false でリングを抑止（キーボードは従来どおり）
 */
class CategoryMega extends HTMLElement {
  constructor() {
    super();
    this._lastOpener = null;
    this._onClick = this._onClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this._onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onClick);
  }

  _onClick(event) {
    const opener = event.target.closest('[data-category-open]');
    if (opener && this.contains(opener)) {
      event.preventDefault();
      this._openPanel(opener, this._isPointerActivation(event));
      return;
    }
    const back = event.target.closest('[data-category-back]');
    if (back && this.contains(back)) {
      event.preventDefault();
      this._closePanel(this._isPointerActivation(event));
    }
  }

  /**
   * @param {PointerEvent | MouseEvent} event
   * @returns {boolean}
   */
  _isPointerActivation(event) {
    const t = event.pointerType;
    return t === 'mouse' || t === 'touch' || t === 'pen';
  }

  /**
   * @param {HTMLElement} element
   * @param {boolean} suppressFocusRing
   */
  _focusWithRingPreference(element, suppressFocusRing) {
    const opts = { preventScroll: true };
    if (suppressFocusRing) {
      opts.focusVisible = false;
    }
    element.focus(opts);
  }

  _openPanel(opener, suppressFocusRing) {
    const targetId = opener.getAttribute('data-category-open');
    const panel = this.querySelector(`[data-category-view="${targetId}"]`);
    const primary = this._getPrimary();
    if (!panel || !primary) return;

    this._lastOpener = opener;
    opener.setAttribute('aria-expanded', 'true');
    primary.hidden = true;
    panel.hidden = false;

    const firstFocusable = panel.querySelector('[data-category-back]');
    if (firstFocusable) {
      this._focusWithRingPreference(firstFocusable, suppressFocusRing);
    }
  }

  _closePanel(suppressFocusRing) {
    const primary = this._getPrimary();
    if (!primary) return;

    const openPanels = this.querySelectorAll('.c_mega-menu-category__view--secondary:not([hidden])');
    openPanels.forEach((panel) => {
      panel.hidden = true;
    });

    const openers = this.querySelectorAll('[data-category-open][aria-expanded="true"]');
    openers.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));

    primary.hidden = false;

    if (this._lastOpener && this.contains(this._lastOpener)) {
      this._focusWithRingPreference(this._lastOpener, suppressFocusRing);
    }
    this._lastOpener = null;
  }

  _getPrimary() {
    return this.querySelector('[data-category-view="primary"]');
  }
}

if (!window.customElements.get('c-category-mega')) {
  window.customElements.define('c-category-mega', CategoryMega);
}
